import Placeholder from '@/pages/Placeholder'

// Pantalla prevista para Fase 2 (MVP2). Albaranes con OCR.
export default function ListaAlbaranes() {
  return (
    <Placeholder
      title="Albaranes"
      description="Digitalización y procesamiento OCR de albaranes. Disponible en Fase 2."
    />
  )
}
